export enum DownloadBinStatusEnum {
    InProgress = 'InProgress',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
}
